<template>
  <div>
    <base-title :title="'Temas'" :subtitle="'Configurações'" :link="'configuracoes'"/>

    <div id="settings-personalize">
        <base-box v-for="(sTheme, iTheme) in oThemes" :key="iTheme" >
            <p class="theme-title">{{ sTheme }}</p>
            <ul class="colors-box">
                <li v-for="(sColor, iColor) in colors" :key="iColor" >
                    <div class="color p_30 p-20-xs" :style="{background: sColor}"></div>
                </li>
            </ul>
        </base-box>

        <div class="d-flex justify-end mb_15">
            <base-button :text="'Aplicar'" @click="save" id="send-personalize"/>
        </div>
    </div>

    <!-- TO DO

    Colocar classe "active" na div.color que foi clicada, para demonstrar seleção.

     -->
  </div>
</template>
<script>
import Theme from "@/plugins/core/schema/configurations/BasicInfo/Theme"
import StoreAPI from '@/api/store'
import Vue from 'vue'

import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseRadio from '@/components/Radio'

export default {
  data () {
    return {
      /** TODO: Incluir no Easy_JSCore */
      oThemes: [
          'Cor primária',
          'Cor secundária',
          'Cor dos botões'
      ],
      colors: [
        '#DB2220',
        '#740100',
        '#FE5F1B',
        '#D53D13',
        '#FFAD2D',
        '#CC8A24',
        '#008E2B',
        '#005B1C',
        '#0068B9',
        '#004B86',
        '#8441AD',
        '#A47EBB',
        '#000000',
      ],
      theme: {}
    }
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseRadio,
  },
  created() {
    self = this
    /* receber objeto cores*/
    self.theme = self.aThemes[0].colors[0].id;
    StoreAPI.storeGetConfiguration('theme').then((response) => {
      self.set(response)
    })
  },
  methods: {
    set(response) {
      if(response.getErrors([]).length > 0) {
        return false
      } else if(response.getData({}).theme || false) {
        let theme = response.getData(new Theme).theme;
        Vue.set(this, 'theme', new Theme(
          theme.color.id,
          theme.color.color1,
          theme.color.color2,
        ).id);
      } else {
        Vue.set(this, 'theme', new Theme());
      }
    },
    get(sColor) {
      for(let iTheme in this.aThemes){
        let aTheme = this.aThemes[iTheme].colors.filter(function(oTheme){
          return sColor === oTheme.id;
        });
        if(aTheme.length > 0){
          return aTheme[0]
        }
      }
    },
    save() {
      let self = this;
      /* Setar objeto cores*/
      StoreAPI.storeConfiguration({
        'theme': {color: self.get(self.theme)}
      }).then((response) => {
        self.set(response)
      })
    }
  }
}
</script>
<style scoped>
  .colors-box{
    display: flex;
    flex-wrap: wrap;
  }

  .theme-title{
    font-size: 1.6em;
    font-weight: 600;
    color: var(--default);
    margin-bottom: 15px;
    opacity: .8;
    margin: 0 0 30px 0;
  }

  .color{
      border-radius: 5px;
      margin-right: 15px;
      margin-bottom: 10px;
  }
</style>